import React from 'react';
import { Grid } from '@mui/material';
import { KeyboardShortcutItemProps } from './ShortcutHelper.props';
import { useKeyboardShortcutItemStyles } from './ShortcutHelper.styles';


const KeyboardShortcutItem = ({ action, combination }: KeyboardShortcutItemProps) => {
  const classes = useKeyboardShortcutItemStyles();

  return (
    <Grid item container direction="row" justifyContent="space-between">
      <Grid item className={classes.action}>
        {action}
      </Grid>
      <Grid item className={classes.combination}>
        {combination}
      </Grid>
    </Grid>
  );
};

export default KeyboardShortcutItem;
